var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisbursed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18934_587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7927 8.51129L22.0113 8.72461H22.3167H38.0667C39.8434 8.72461 41.2542 10.1274 41.2542 11.8184V12.3496H0.75415V6.69336C0.75415 5.00244 2.1649 3.59961 3.94165 3.59961H16.7613L21.7927 8.51129ZM3.94165 37.9746C2.1649 37.9746 0.75415 36.5718 0.75415 34.8809V16.4121H41.2542V34.8809C41.2542 36.5718 39.8434 37.9746 38.0667 37.9746H3.94165Z",
    stroke: "#CE1111",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18934_587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 41,
    fill: "white",
    transform: "translate(0.00415039 0.287109)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisbursed);
export default __webpack_public_path__ + "static/media/disbursed.1916ffa0c7331701cf08083532d3d8e7.svg";
export { ForwardRef as ReactComponent };